import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=2e793aef&"
import script from "./Heading.vue?vue&type=script&lang=js&"
export * from "./Heading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports